import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { UsatoCard } from "@/components/UsatoCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Strip di auto usate correlate: in home ("Ultimi arrivi") o nella pagina di un modello NLT
 * ("disponibile anche usata"). Non renderizza nulla se lo stock non ha corrispondenze.
 */
export const UsatoStrip = ({ marca, modello, limit = 3, titolo, sottotitolo, testid = "usato-strip" }) => {
  const [lista, setLista] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams({ limit });
    if (marca) params.set("marca", marca);
    if (modello) params.set("modello", modello);
    axios.get(`${API}/usato/simili?${params}`).then((r) => {
      // Per un modello NLT mostriamo solo corrispondenze reali (stessa marca), non riempitivi generici
      setLista(marca ? r.data.filter((a) => a.marca.toLowerCase() === marca.toLowerCase()) : r.data);
    }).catch(() => setLista([]));
  }, [marca, modello, limit]);

  if (!lista.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-testid={testid}>
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">NLT SecondLife · Usato garantito</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-xmove-ink sm:text-3xl">{titolo}</h2>
            {sottotitolo && <p className="mt-2 max-w-2xl text-sm text-xmove-muted">{sottotitolo}</p>}
          </div>
          <Link to={marca ? `/usato/marca/${marca.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}/` : "/usato/"} className="inline-flex items-center gap-1.5 text-sm font-bold text-xmove-orange hover:underline" data-testid={`${testid}-link`}>
            {marca ? `Tutte le ${marca} usate a noleggio` : "Tutto il noleggio lungo termine usato"} <ArrowRight size={15} />
          </Link>
        </div>
        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {lista.map((a) => <UsatoCard key={a.vehicleid} auto={a} />)}
        </div>
      </Reveal>
    </section>
  );
};
